module.exports = __webpack_public_path__ + "static/img/logo--en.6b4394b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo--en.svg
// module id = WS7M
// module chunks = 1